import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import { Box, Button, Typography, CardContent, CardActions, Skeleton } from '@mui/material';
import { BaseCard } from '../../components/Common/BaseCard';
import routes from '../../routes';

const FoodDonorPendingMobileCard = ({ foodDonor, isLoading }) => (
  <BaseCard>
    <CardContent>
      <Box display="flex">
        <Box flexGrow={1} display="flex" justifyContent="flex-start" flexDirection="row" alignItems="stretch">
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <Typography variant="subtitle1">
              <strong>Food Donor Location Name</strong>
            </Typography>
            <Typography variant="body1"> {isLoading ? <Skeleton /> : foodDonor.name}</Typography>
          </Box>
        </Box>
      </Box>
    </CardContent>

    <CardActions disableSpacing sx={(theme) => ({ padding: theme.spacing(0, 2, 2, 2) })}>
      <Button
        data-testid="details-button"
        variant="contained"
        color="primary"
        component={Link}
        to={generatePath(routes.foodDonorRegistrationReview, { foodDonorId: foodDonor.id })}
      >
        Verify
      </Button>
    </CardActions>
  </BaseCard>
);

export default FoodDonorPendingMobileCard;
